<template>
  <div class="cart-info-container">
    <div class="form-container">
      <div class="order-info-title">
        <h4>
          購物車 > 運送與收件資訊
          <span>> 選擇付款方式</span>
        </h4>
      </div>
      <form>
        <div class="notice">
          <h4>
            聯絡通知<span v-if="!isLogin">已經有帳號了？</span>
            <router-link to="/gold/member_login" v-if="!isLogin"
              >登入 (登入後即可搜尋訂單資訊)</router-link
            >
          </h4>
          <div class="myRadio">
            <input
              type="radio"
              id="emailNotice"
              name="notificationSelector"
              v-model="receiverInfo.notification"
              value="電子郵件通知"
              checked
            />
            <label for="emailNotice">電子郵件通知</label>
            <div class="check"></div>
          </div>
          <p>如有商品上的變更或通知我們會以該方式通知。</p>
        </div>
        <div class="notice">
          <h4>確認排版通知</h4>
          <div class="myRadio">
            <input
              type="radio"
              id="NoNeed"
              name="typesetting"
              checked
              v-model="is_check"
              value="0"
            />
            <label for="NoNeed">不需要</label>
            <div class="check"></div>
          </div>
          <div class="myRadio">
            <input
              type="radio"
              id="need"
              name="typesetting"
              checked
              v-model="is_check"
              value="1"
            />
            <label for="need">需要</label>
            <div class="check"></div>
          </div>
          <p>
            目前畫面呈現為示意圖，正式稿件將由專業人員編排製版。如有需要確認排版請勾選需要，我們會將正式稿件發送至您的電子信箱，亦可加入官方
            line@ 進行製版確認哦
          </p>
          <img src="https://qr-official.line.me/L/M25Jjb7obw.png" />
        </div>
        <div>
          <h4>寄送方式</h4>
          <div class="myRadio">
            <input
              type="radio"
              id="delivery_post"
              name="sendWaySelector"
              v-model="receiverInfo.sendWay"
              checked
              value="郵局宅配"
            />
            <label for="delivery_post">郵局宅配</label>
            <div class="check"></div>
          </div>
          <div class="myRadio">
            <input
              type="radio"
              id="delivery_self"
              name="sendWaySelector"
              v-model="receiverInfo.sendWay"
              checked
              value="自取"
            />
            <label for="delivery_self">自取</label>
            <div class="check"></div>
          </div>
        </div>
        <div>
          <h4>收貨人資料</h4>
          <div class="myRadio" v-if="isLogin">
            <input type="checkbox" id="memberInfo" v-model="infoEqual" />
            <label for="memberInfo">{{
              isSpecialMember ? "同特約會員資料:" : "同會員資料:"
            }}</label>
            <div class="check"></div>
          </div>
          <div class="name-container flex-container">
            <div class="flex-item">
              <div class="form-title">
                {{ isSpecialMember ? "姓名" : "名字" }}
              </div>
              <input
                type="text"
                required
                v-if="infoEqual"
                v-model="memberInfo.firstName"
              />
              <input
                type="text"
                required
                v-else
                v-model="receiverInfo.firstName"
              />
            </div>
            <div class="flex-item" v-if="!isSpecialMember">
              <div class="form-title">姓氏</div>
              <input
                type="text"
                required
                v-if="infoEqual"
                v-model="memberInfo.lastName"
              />
              <input
                type="text"
                required
                v-else
                v-model="receiverInfo.lastName"
              />
            </div>
          </div>
          <div>
            <div class="form-title">手機</div>
            <input
              type="text"
              required
              v-if="infoEqual"
              v-model="memberInfo.phone"
              pattern="[0-9]{0,255}"
              oninvalid="setCustomValidity('請輸入手機號碼(純數字)')"
              oninput="setCustomValidity('')"
            />
            <input
              type="text"
              required
              v-else
              v-model="receiverInfo.phone"
              pattern="[0-9]{0,255}"
              oninvalid="setCustomValidity('請輸入手機號碼(純數字)')"
              oninput="setCustomValidity('')"
            />
          </div>
          <div>
            <div class="form-title">電子信箱</div>
            <input
              class="emailExamine"
              type="email"
              required
              v-if="infoEqual"
              v-model="memberInfo.email"
              placeholder="例:abc123@gmail.com"
            />
            <input
              class="emailExamine"
              type="email"
              required
              v-else
              v-model="receiverInfo.email"
              placeholder="例:abc123@gmail.com"
            />
          </div>
          <div>
            <div class="form-title">住址</div>
            <div class="address-container">
              <div class="flex-container">
                <input
                  class="flex-item"
                  type="text"
                  placeholder="台灣"
                  v-if="infoEqual"
                  v-model="memberInfo.country"
                  data-item="country"
                />
                <input
                  class="flex-item"
                  type="text"
                  placeholder="台灣"
                  v-else
                  v-model="receiverInfo.country"
                  data-item="country"
                />
                <div class="dropdown-title flex-item">
                  <a
                    href="#"
                    v-on:click.prevent="showDropDown_city = !showDropDown_city"
                  >
                    <div :class="{ 'title-color': chooseCity === '' }">
                      {{ chooseCity ? chooseCity : "縣市" }}
                    </div>
                    <i
                      :class="{
                        'fa-caret-up': showDropDown_city,
                        'fa-caret-down': !showDropDown_city,
                      }"
                      class="fa"
                      aria-hidden="true"
                    ></i>
                  </a>
                  <transition name="slide-fade">
                    <div class="choice" v-if="showDropDown_city">
                      <ul>
                        <li
                          v-for="(city, index) in displayCityList"
                          :key="index"
                          @click="showDropDown_city = !showDropDown_city"
                        >
                          <span class="item" @click="chooseCity = city">{{
                            city
                          }}</span>
                        </li>
                      </ul>
                    </div>
                  </transition>
                </div>
                <div class="dropdown-title flex-item">
                  <a
                    href="#"
                    v-on:click.prevent="
                      showDropDown_zipcode = !showDropDown_zipcode
                    "
                  >
                    <div :class="{ 'title-color': displayZipCodeInfo === '' }">
                      {{ displayZipCodeInfo ? displayZipCodeInfo : "郵遞區號" }}
                    </div>
                    <i
                      :class="{
                        'fa-caret-up': showDropDown_zipcode,
                        'fa-caret-down': !showDropDown_zipcode,
                      }"
                      class="fa"
                      aria-hidden="true"
                    ></i>
                  </a>
                  <transition name="slide-fade">
                    <div class="choice" v-if="showDropDown_zipcode">
                      <ul v-if="infoEqual">
                        <li
                          v-for="(zipcode, index) in displayZipCodeList"
                          :key="index"
                          @click="showDropDown_zipcode = !showDropDown_zipcode"
                        >
                          <span
                            class="item"
                            @click="memberInfo.postalCode = zipcode.zopcode"
                            >{{ zipcode.region + zipcode.zopcode }}</span
                          >
                        </li>
                      </ul>
                      <ul v-else>
                        <li
                          v-for="(zipcode, index) in displayZipCodeList"
                          :key="index"
                          @click="showDropDown_zipcode = !showDropDown_zipcode"
                        >
                          <span
                            class="item"
                            @click="receiverInfo.postalCode = zipcode.zopcode"
                            >{{ zipcode.region + zipcode.zopcode }}</span
                          >
                        </li>
                      </ul>
                    </div>
                  </transition>
                </div>
              </div>
              <input
                type="text"
                placeholder="地址"
                required
                v-if="infoEqual"
                v-model="memberInfo.address"
                data-item="address"
              />
              <input
                type="text"
                placeholder="地址"
                required
                v-else
                v-model="receiverInfo.address"
                data-item="address"
              />
            </div>
          </div>
        </div>
        <div>
          <h4>發票資訊</h4>
          <div v-if="isSpecialMember">特約廠商購買無發票</div>
          <div v-if="!isSpecialMember">
            <div class="myRadio">
              <input
                type="radio"
                id="personal"
                name="invoiceType"
                v-model="receiverInfo.invoiceType"
                value="個人"
              />
              <label for="personal">個人</label>
              <div class="check"></div>
            </div>
            <div class="myRadio" v-if="!isSpecialMember">
              <input
                type="radio"
                id="company"
                name="invoiceType"
                v-model="receiverInfo.invoiceType"
                value="公司"
              />
              <label for="company">公司</label>
              <div class="check"></div>
            </div>
            <div
              class="flex-container invoice"
              v-if="receiverInfo.invoiceType == '公司'"
            >
              <input
                class="flex-item"
                type="text"
                placeholder="抬頭"
                required
                v-model="receiverInfo.invoiceHead"
              />
              <input
                class="flex-item"
                type="text"
                placeholder="統一編號"
                required
                v-model="receiverInfo.invoiceNum"
                pattern="[0-9]{8,8}"
              />
            </div>
          </div>
        </div>
      </form>
      <div class="bottom-links-wrap">
        <div>
          <button @click="nextStep">選擇付款方式</button>
        </div>
      </div>
    </div>
    <CartOrdershow id="ordershow"></CartOrdershow>
  </div>
</template>

<script>
import CartOrdershow from "@/components/cart/cart_ordershow.vue";
import Cookies from "js-cookie";
import axios from "axios";
import taiwanZipcodeData from "@/constData/taiwanZipCode.js";

export default {
  name: "CartInfo",
  components: {
    CartOrdershow,
  },
  beforeRouteEnter: (to, from, next) => {
    if (from.name == "cart_confirm") {
      next((vm) => {
        if (Cookies.getJSON("receiptInfo") !== undefined) {
          vm.receiverInfo = Cookies.getJSON("receiptInfo");
          vm.chooseCity = vm.$store.getters.getCityByZipcode(
            vm.receiverInfo.postalCode
          );
        }
        if (Cookies.getJSON("infoEqual") == undefined) {
          vm.infoEqual = false;
        } else if (Cookies.getJSON("infoEqual") == "1") {
          vm.infoEqual = true;
        } else if (Cookies.getJSON("infoEqual") == "0") {
          vm.infoEqual = false;
        }
        if (Cookies.getJSON("isCheck") !== undefined) {
          vm.is_check = Cookies.getJSON("isCheck");
        }
      });
    } else {
      next();
    }
  },
  created() {
    this.memberInfo = this.$store.getters.getMemberInfo;
    this.timeToLeave();
    if (this.isSpecialMember) {
      this.receiverInfo.invoiceType = "同業";
      let specialMemberInfo = this.$store.getters.getSpecialMemberData;
      this.memberInfo = {
        firstName: specialMemberInfo.principal_name,
        lastName: "",
        phone: specialMemberInfo.principal_phone,
        email: specialMemberInfo.principal_email,
        country: specialMemberInfo.company_address_country,
        postalCode: specialMemberInfo.company_address_postal_code,
        address: specialMemberInfo.company_address,
      };
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== "cart_confirm" && to.name !== "cart_finish") {
      let userResponse = confirm("您填寫的資料可能會遺失，確定離開嗎？");
      if (userResponse) {
        // this.$store.dispatch("resetReceiverInfo");
        next();
      }
    } else {
      next();
    }
  },
  data() {
    return {
      memberInfo: "",
      infoEqual: false,
      receiverInfo: {
        notification: "電子郵件通知",
        sendWay: "郵局宅配",
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        country: "台灣",
        postalCode: "",
        address: "",
        invoiceType: "個人",
        invoiceHead: "",
        invoiceNum: "",
      },
      is_check: "0",
      showDropDown_city: false,
      showDropDown_zipcode: false,
      taiwanZipcodeData: taiwanZipcodeData.taiwanZipcodeData,
      chooseCity: "",
    };
  },
  watch: {
    infoEqual() {
      if (this.infoEqual) {
        this.chooseCity = this.$store.getters.getCityByZipcode(
          this.memberInfo.postalCode
        );
      } else {
        if (this.receiverInfo.postalCode !== "") {
          this.chooseCity = this.$store.getters.getCityByZipcode(
            this.receiverInfo.postalCode
          );
        } else {
          this.chooseCity = "";
        }
      }
    },
  },
  methods: {
    // updateReceiptInfo() {
    //   let payload = this.receiverInfo;
    //   this.$store.dispatch("updateReceiptInfo", payload);
    // },
    nextStep() {
      if (this.infoEqual) {
        this.letInfoEqual();
      }
      let checkResult = this.examineData();
      if (checkResult == "error") {
        return;
      }
      if (this.infoEqual) {
        Cookies.set("infoEqual", "1");
      } else {
        Cookies.set("infoEqual", "0");
      }
      Cookies.set("receiptInfo", this.receiverInfo);
      Cookies.set("isCheck", this.is_check);
      // this.updateReceiptInfo();
      this.$router.push("/gold/cart/cart_confirm");
    },
    letInfoEqual() {
      this.receiverInfo.firstName = this.memberInfo.firstName;
      this.receiverInfo.lastName = this.memberInfo.lastName;
      this.receiverInfo.phone = this.memberInfo.phone;
      this.receiverInfo.email = this.memberInfo.email;
      this.receiverInfo.country = this.memberInfo.country;
      this.receiverInfo.postalCode = this.memberInfo.postalCode;
      this.receiverInfo.address = this.memberInfo.address;
    },
    examineData() {
      let email = document.querySelector(".emailExamine");
      let allInput = document.querySelectorAll("input");
      allInput.forEach((item) => {
        item.style.border = "1px solid #a8894c";
      });
      email.style.border = "1px solid #a8894c";
      let errorData = document.querySelectorAll("input:invalid");
      let emailExamine = /^.*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
      if (errorData.length !== 0) {
        alert("尚有聯絡資料未填寫或格式錯誤");
        errorData.forEach((item) => {
          item.style.border = "2px solid red";
        });
        return "error";
      }
      if (this.infoEqual) {
        if (!emailExamine.test(this.memberInfo.email)) {
          email.style.border = "2px solid red";
          return "error";
        }
      } else {
        if (!emailExamine.test(this.receiverInfo.email)) {
          email.style.border = "2px solid red";
          return "error";
        }
      }
      return "ok";
    },
    timeToLeave() {
      setTimeout(
        function () {
          this.$router.push("/gold/homepage");
        }.bind(this),
        3600000
      );
    },
  },
  computed: {
    isLogin() {
      let token = this.$store.getters.getToken;
      if (token !== "") {
        return true;
      } else {
        return false;
      }
    },
    checkoutForm() {
      return this.$store.getters.getCheckoutForm;
    },
    isSpecialMember() {
      if (this.$store.getters.getToken === "") {
        return false;
      } else if (this.$store.getters.getSpecialMemberState === null) {
        return false;
      } else if (this.$store.getters.getSpecialMemberState === 0) {
        return false;
      } else {
        return true;
      }
    },
    displayCityList() {
      let cityList = [];
      for (let city in this.taiwanZipcodeData) {
        cityList.push(city);
      }
      return cityList;
    },
    displayZipCodeList() {
      if (this.chooseCity !== "") {
        let zipcodeList = [];
        this.taiwanZipcodeData[`${this.chooseCity}`].forEach((item) => {
          let keyValue = Object.entries(item)[0];
          zipcodeList.push({
            region: keyValue[0],
            zopcode: keyValue[1],
          });
        });
        return zipcodeList;
      } else {
        return [];
      }
    },
    displayZipCodeInfo() {
      let displayZipCode = "";
      let code = "";
      if (this.chooseCity === "") {
        return "";
      }
      if (this.infoEqual) {
        code = this.memberInfo.postalCode;
      } else {
        code = this.receiverInfo.postalCode;
      }
      for (let cityValue in this.taiwanZipcodeData) {
        this.taiwanZipcodeData[`${this.chooseCity}`].forEach((region) => {
          for (let regionName in region) {
            if (region[`${regionName}`] === code) {
              displayZipCode = regionName + region[`${regionName}`];
            }
          }
        });
      }
      return displayZipCode;
    },
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.cart-info-container {
  display: flex;
  flex-wrap: nowrap;
  padding-left: 105px;
  justify-content: space-between;
  @include table {
    flex-wrap: wrap;
    padding: 0;
    flex-direction: column-reverse;
  }
}
#ordershow {
  box-sizing: content-box;
  max-width: 600px;
  width: 38%;
  @include table {
    width: 100%;
    max-width: 768px;
    box-sizing: border-box;
  }
}
.form-container {
  padding-bottom: 75px;
  text-align: left;
  font-size: 17px;
  color: $secondaryDeepColor1;
  @include table {
    padding: 16px;
  }
}
.order-info-title > h4 > span:first-of-type {
  color: $secondaryLightColor1;
}
h4 {
  margin-top: 30px;
  margin-bottom: 16px;
}
.notice {
  // & > h4 > span:first-of-type {
  //   margin-left: 16px;
  //   font-weight: initial;
  // }
  p {
    color: $secondaryColor2;
    margin-top: 7px;
  }
  img {
    width: 151px;
    vertical-align: middle;
  }
}
.name-container {
  .flex-item {
    width: 48%;
    @include table {
      width: 100%;
    }
  }
}
.flex-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.address-container {
  .flex-item {
    width: 32%;
    @include table {
      width: 100%;
    }
  }
  .flex-container {
    margin-bottom: 15px;
    @include table {
      margin-bottom: 0;
    }
  }
  .flex-container > * {
    @include table {
      margin-bottom: 15px;
    }
  }
}
.form-title {
  margin-top: 15px;
  margin-bottom: 8px;
  font-weight: 600;
}
input {
  width: 100%;
  padding: 16px;
  font-size: 17px;
  border: 1px solid $primaryDeepColor;
  background-color: rgba(0, 0, 0, 0);
}
.bottom-links-wrap {
  @include table {
    text-align: center;
  }
}
button {
  @extend %button;
  margin-top: 16px;
  @include table {
    width: 100%;
    max-width: 343px;
  }
}

/*******************************
radio style
*******************************/
.myRadio {
  position: relative;
}
.myRadio label {
  font-weight: normal;
  display: block;
  position: relative;
  padding: 8px 41px;
  z-index: 9;
  cursor: pointer;
  .sameCompany-info {
    color: #fb6e6b;
  }
}
// .myRadio:hover label {
//   color: #bf9f5f;
// }

.myRadio .check {
  position: absolute;
  border: 2px solid #a8894c;
  border-radius: 50%;
  height: 25px;
  width: 25px;
  top: 8px;
  left: 0;
  z-index: 5;
}
.myRadio:hover .check {
  border: 2px solid #bf9f5f;
}

.myRadio .check::before {
  display: block;
  position: absolute;
  content: "";
  border-radius: 50%;
  height: 15px;
  width: 15px;
  top: 3px;
  left: 3px;
  margin: auto;
}
.myRadio input[type="radio"] {
  position: absolute;
  visibility: hidden;
}

.myRadio input[type="checkbox"] {
  position: absolute;
  visibility: hidden;
}

input[type="radio"]:checked ~ .check::before {
  background: #a8894c;
}

input[type="checkbox"]:checked ~ .check::before {
  background: #a8894c;
}

input[type="radio"]:checked ~ label {
  color: #a8894c;
}

// input[type="checkbox"]:checked ~ label {
//   color: #a8894c;
// }

//dropdown
.dropdown-title {
  position: relative;
  a,
  .item {
    color: $secondaryDeepColor1;
    text-decoration: none;
    display: flex;
    align-items: center;
    border: 1px $primaryDeepColor solid;
    padding: 15px 15px 15px 10px;
    width: 100%;
  }
  a {
    background-color: rgba(0, 0, 0, 0);
  }
  .item {
    background-color: #fefff9;
  }
  .item:hover {
    color: $secondaryColor3;
    background-color: $primaryLightColor;
  }
  .title-color {
    color: $secondaryLightColor1;
  }
}
ul {
  display: block;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.choice {
  position: absolute;
  width: 100%;
  z-index: 99;
  max-height: 365px;
  overflow-y: scroll;
}
.fa {
  margin-left: auto;
  color: $primaryLightColor;
}
</style>
